
(() => {
  if (customElements.get('cart-drawer-recommendations')) return;

  customElements.define(
    'cart-drawer-recommendations',
    class extends HTMLElement {
      connectedCallback() {
        this.loadRecommendations();
      }

      async loadRecommendations() {
        const productId = this.dataset.productId;
        const sectionId = this.dataset.sectionId;
        const limit = this.dataset.limit || 4;
        const url = this.dataset.url;

        if (!productId || !sectionId || !url) {
          this.remove();
          return;
        }

        const params = new URLSearchParams({
          product_id: productId,
          limit: limit,
          intent: 'related',
          section_id: sectionId
        });

        try {
          const response = await fetch(`${url}?${params.toString()}`, {
            credentials: 'same-origin',
            headers: { Accept: 'text/html' }
          });

          if (!response.ok) {
            throw new Error(
              `Recommendations request failed: ${response.status}`
            );
          }

          const html = await response.text();
          const doc = new DOMParser().parseFromString(
            html,
            'text/html'
          );

          const content = doc.querySelector(
            '.cart-drawer-recommendations__inner'
          );

          if (!content) {
            this.remove();
            return;
          }

          this.replaceChildren(content.cloneNode(true));
        } catch (error) {
          console.error(
            'Unable to load cart recommendations:',
            error
          );
          this.remove();
        }
      }
    }
  );
})();
